import { writable } from "svelte/store";
import { configurationSymbol, positionInPaneSymbol, stateSymbol, svgTextSizeSymbol, zoomToFitSymbol, getSVGSymbol } from "./context";
import { setContext } from "svelte";
import { getInitialMachineState, initialState } from "./state/state";
export function setPositionInPane(positionInPane) {
    setContext(positionInPaneSymbol, positionInPane);
}
export function setGetSVG(getSVG) {
    setContext(getSVGSymbol, getSVG);
}
export function createStores(system) {
    const state = Object.assign(Object.assign({}, initialState), { machineState: getInitialMachineState(system) });
    let stateStore = writable(state);
    setContext(stateSymbol, stateStore);
    let zoomToFitStore = writable(() => { });
    setContext(zoomToFitSymbol, zoomToFitStore);
    let getSVGStore = writable(() => '');
    setContext(getSVGSymbol, getSVGStore);
}
export function setConfiguration(configuration) {
    setContext(configurationSymbol, configuration);
}
export function setSVGTextSize(svgTextSize) {
    setContext(svgTextSizeSymbol, svgTextSize);
}
